import { useContext, useMemo } from 'react';
import { getFilteredItems } from '../../../Utils/items';
import { bookingState } from '../client-state/booking-state-context';
import Items, { ItemType } from '../../../ui-components/Items';
import useBookingShop from '../server-data/use-booking-shop';
import useBookingTracking from 'Hooks/useBookingTracking';
import { View } from '../../../Utils/graphql-sdk';

const ItemsWithData = () => {
  const { data: shop } = useBookingShop();
  const { state } = useContext(bookingState);
  const track = useBookingTracking();

  const filteredItems = useMemo(() => {
    return getFilteredItems({
      items: shop?.items || [],
      bookingDate: state.booking.date,
      timezone: shop?.timezoneName,
      selectedCategoryId: state.selectedItemCategory,
      pageType: View.Prebook,
      duration: state.booking.duration,
    });
  }, [
    shop?.items,
    state.booking.date,
    shop?.timezoneName,
    state.selectedItemCategory,
    state.booking.duration,
  ]);

  const onViewItemDetail = (item: ItemType) => {
    track({ type: 'VIEW_ITEM_DETAIL', item });
  };

  const onChangeItemQuantity = (item: ItemType, quantity: number) => {
    track({ type: 'CHANGE_ITEM_QUANTITY', item: { ...item, quantity } });
  };

  const onChangeItemsPage = (index: number) => {
    track({ type: 'CHANGE_ITEMS_PAGE', newStep: index });
  };

  return (
    <Items
      items={filteredItems}
      currentCategory={state.selectedItemCategory}
      itemsPerPage={shop?.shopSettings?.booking.itemsPerPage}
      onViewItemDetail={onViewItemDetail}
      onChangeItemQuantity={onChangeItemQuantity}
      onChangeItemsPage={onChangeItemsPage}
    />
  );
};

export default ItemsWithData;
